import get from 'lodash/get';
import type { AxiosInstance } from 'axios';
import $axios from '../AxiosService';
import { getNetworkErrorType } from '~/utils/Utilities';

const UserActionsService = {
  async getCurrentUser(_axios: () => AxiosInstance) {
    try {
      /**
       * Passing axios from the middleware because $axios isn't available at this point in Nuxt's lifecycle
       * Middlewares are run before plugins
       */
      let axios = null;
      if ($axios()) {
        axios = $axios;
      } else {
        axios = _axios;
      }

      const response = await (axios as any)().get('/user?subscriptionData=true');
      const userData = get(response, 'data.data.user', null);
      return userData;
    } catch (err) {
      return {
        success: false,
        error: err,
      };
    }
  },

  async logout() {
    try {
      await $axios().get('/logout');
    } catch (err) {
      const cause = getNetworkErrorType(err);
      return {
        success: false,
        error: {
          cause,
        },
      };
    }
  },
};

export default UserActionsService;
